import React, {useRef} from "react";
import {PopupPanel} from "../tools/UIPopMenu";
import {useColorModeTheme} from "../tools/CommonReact";
import {dispUserName, Divider, getUserIfExt, LetterAvatar, Title} from "../app/CommonUIComponenets";
import {appCtx, genTooltip} from "../app/AppContext";
import {icn} from "../tools/UIIcons";
import {Button, TextInput, useInputChange} from "../tools/Inputs";
import {useSidePanel} from "../tools/UIPopSidePanel";
import {useFeatureFlags, useCheckRefresh, useUser} from "../app/UseAppData";
import {SearchGlobalPanel} from "./GlobalSearch";
import {Switch} from "../tools/UIControls";
import {objToArrK} from "../tools/CommonJS";
import {checkRum} from "../app/rum";

const themeMenuDefs = {
    light: {h: "Light", i: icn.sun},
    dark: {h: "Dark", i: <i className="h-4 w-4 text-end leading-4 block icon-moon-o text-title"/>} ,
    // "": {h: "System", i: icn.sunCloud},
}, themeMenuDefsOpts = objToArrK(themeMenuDefs);

export function NavBar() {
    const vals = useRef({}).current;
    const {curTheme, setTheme} = useColorModeTheme();
    const {inp, onChange} = useInputChange({search: ""})
    const {setPanel, panelsJsx} = useSidePanel();
    const {user, signOut} = useUser();
    const {rsp: ftrFlags} = useFeatureFlags();
    checkRum({vals, ftrFlags});
    useCheckRefresh();

    const openSearch = () => vals.panelId = setPanel({
        Elm: SearchGlobalPanel, panelId: vals.panelId,
        className: "bg-bg2 w-[28rem] h-[100vh] top-0 right-0 p-4 rounded-l-xl shadow-lg",
        classNameOverlay: "bg-handle"
    });

    return (
        <div className="h-20 shrink-0 px-8 flex items-center gap-4 bg-bg2">
            <Breadcrumbs className="grow"/>
            {/*<RefreshButton obj={refreshData} onRefresh={refreshData?.onRefresh}/>*/}
            <div className="flex items-center gap-6">
                <TextInput placeholder="Global Search" onFocus={openSearch} field="global-search" className="min-w-12" value={inp.search} onChange={onChange}/>
                <Button className="icon-activity cursor-pointer" {...genTooltip("My Activity")}
                        onClick={() => appCtx.nav.to("/action_log", {user: user?.user}, {isReset: true})} disabled={!user}/>
                <PopupPanel
                    button={<Button>
                        <LetterAvatar user={user?.userName || user?.user} className="h-8 bg-[#5f5e90] ring-[#28248b] ring-2 border-2 border-bg2"/>
                    </Button>}
                    align="bottom-right"
                    onShowPanel={() =>
                        <div className="bg-popup border-prm-main border p-2 text-title rounded-lg whitespace-pre shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none flex flex-col gap-2">
                            <div className="flex gap-2 items-center">
                                <i className="icon-user text-xl border-2 border-tx-steel ring-1 ring-prm-main rounded-full w-fit h-fit px-2 py-1"/>
                                <div className="flex text-h2 flex-col gap-1">
                                    <div className="px-2 font-semibold">{dispUserName(user)}</div>
                                    <div className="px-2">{getUserIfExt(user)}</div>
                                </div>
                            </div>
                            {signOut && <>
                                <Divider/>
                                <Button className="px-2 w-full justify-center text-sm gap-1" onClick={signOut}>
                                    <i className="icon-exit"/> Logout
                                </Button>
                            </>}
                        </div>
                    }
                />
                <Switch
                    onChange={_ => setTheme(curTheme !== "dark" ? "dark" : "light")}
                    value={curTheme}
                    field= {"theme"}
                    opts={themeMenuDefsOpts}
                />
            </div>
            {panelsJsx}
        </div>
    );
}


export function Breadcrumbs({className}) {
    const paths = appCtx.nav.getPaths();

    return (
        <div className={`${className} flex items-center gap-4 min-w-0`}>
            {paths.length > 1 &&
                <Button onClick={()=> appCtx.nav.navUp(paths.length - 2)}
                        data-test="back-button"
                        className="shrink-0 icon-back text-prm-light text-sm border border-prm-light rounded-full w-7 h-7 flex items-center justify-center"/>}
            <div className="flex flex-col overflow-hidden">
                <div className="flex items-center flex-wrap gap-2">
                    {paths?.slice(0, -1).map((path, i) =>
                        <div key={i} className="flex items-center justify-start gap-2 text-sm text-prm-light">
                            <Button onClick={()=> appCtx.nav.navUp(i)} h={appCtx.nav.getTitle(i)}/>
                            {i < paths.length - 1 && <span className="text-xs">{">"}</span>}
                        </div>
                    )}
                </div>
                <Title data-test="page-title" children={appCtx.nav.getTitle()} className="text-[1.75rem]"/>
            </div>
        </div>
    );
}
